import React from 'react';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { NewsEarnings } from '$/components/news-earnings';
import { getIsCurrentUserClientState } from '$/store/profile/selectors';
import { NewsClientService } from '$/services';
import { IFilterItem } from '$/components/sortFilter/filterItem';

interface INewsEarningsProps {
  filters: IFilterItem[];
  settings?: Bixby.Models.Settings;
  companyId?: string;
  companyName?: string;
  dataSiteName?: string;
  isClient: boolean;
  profile?: Bixby.Models.Profile;
}

const ClientNewsEarnings: React.FC<INewsEarningsProps> = props => {
  const { filters, settings, companyId, companyName, dataSiteName, isClient, profile } = props;

  return (
    <NewsEarnings
      filters={filters}
      settings={settings}
      companyId={companyId}
      companyName={companyName}
      dataSiteName={dataSiteName}
      isClient={isClient}
      profile={profile}
      getNews={() => (companyId ? NewsClientService.getNewsByCompanyId(companyId) : NewsClientService.getNews())}
      getNewsEntry={(id: string) => NewsClientService.getById(id)}
    />
  );
};

const mapDispatchToProps = () => ({});

const mapStateToProps = (state: AppState) => {
  const { isClient } = getIsCurrentUserClientState(state);

  return {
    filters: (state.newsFiltersState.data || []).map(filter => {
      const { id, name } = filter;
      return { id, name, active: false } as IFilterItem;
    }),
    settings: state.settingsState.settings,
    isClient: isClient,
    profile: state.profileState.profile,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientNewsEarnings);
